import { api } from '@/api';
import { handleQueryLifecycle } from '@/api/utils.ts';
import { setChatTitle, updateChatHistoryTitle, type RootState } from '@/store';
import { getChatHistoryApi } from './getChatHistory';
import { getMatterChatsApi } from './getMatterChats';

export interface EditChatTitleRequest {
  chatId: string;
  chatTitle: string;
}

export interface EditChatTitleResponse {
  chatTitle: string;
}

const editChatTitleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    editChatTitle: builder.mutation<EditChatTitleResponse, EditChatTitleRequest>({
      query: ({ chatId, chatTitle }) => ({
        url: '/chat/edit-title',
        method: 'POST',
        body: {
          chat_id: chatId,
          title: chatTitle,
        },
      }),
      async onQueryStarted(arg, { dispatch, getState, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, ({ chatTitle }) => {
          dispatch(setChatTitle({ chatTitle }));
          dispatch(updateChatHistoryTitle({ chatId: arg.chatId, title: chatTitle }));
          // The sidebar's recent chats only refetch on a send or a change to the open chat's title.
          getChatHistoryApi.util.selectCachedArgsForQuery(getState() as RootState, 'getChatHistory').forEach((args) =>
            dispatch(
              getChatHistoryApi.util.updateQueryData('getChatHistory', args, (draft) => {
                const chat = draft.chats.find((historyChat) => historyChat.chatId === arg.chatId);
                if (chat) chat.title = chatTitle;
              }),
            ),
          );
          getMatterChatsApi.util.selectCachedArgsForQuery(getState() as RootState, 'getMatterChats').forEach((args) =>
            dispatch(
              getMatterChatsApi.util.updateQueryData('getMatterChats', args, (draft) => {
                const chat = draft.chats.find((matterChat) => matterChat.chatId === arg.chatId);
                if (chat) chat.title = chatTitle;
              }),
            ),
          );
        });
      },
    }),
  }),
});

export const { useEditChatTitleMutation } = editChatTitleApi;
